import {
  CalendarOutlined,
  CopyOutlined,
  HomeOutlined,
  MailOutlined,
  PhoneOutlined,
  QrcodeOutlined,
  SearchOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Alert,
  Avatar,
  Button,
  Card,
  Col,
  Descriptions,
  Divider,
  Input,
  message,
  Row,
  Space,
  Typography,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { registrationApi } from "../../../api/registrationApi";
import { useEvent } from "../../../hooks/useEvent";
import { useCheckIn } from "../../../hooks/useRegistration";

const { Title, Text } = Typography;
const { TextArea } = Input;

const borrowStatus = {
  pending: "Chờ nhận",
  borrowed: "Đã mượn",
  returned: "Đã trả",
  lost: "Mất",
  cancelled: "Đã hủy",
};

export function EventCheckOut() {
  const { id } = useParams();
  const eventId = id;
  const [qrCode, setQrCode] = useState("");
  const { checkOutQR } = useCheckIn();

  const { data: event } = useEvent(eventId);

  // Lấy thông tin từ QR code
  const [data, setData] = useState(null);
  const inputRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();

    const keepFocus = () => {
      if (document.activeElement !== inputRef.current) {
        inputRef.current?.focus();
      }
    };

    const interval = setInterval(keepFocus, 100);

    return () => {
      clearInterval(interval);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  // const handleCheckOut = async () => {
  //   if (!qrCode.trim()) {
  //     message.warning("Vui lòng nhập mã QR!");
  //     return;
  //   }

  //   setQrCode("");
  //   setData(null);

  //   try {
  //     await checkOutQR.mutateAsync(qrCode.trim());
  //     message.success("✅ Check-out thành công!");
  //     setQrCode("");
  //   } catch (error) {
  //     message.error(error.message || "❌ Check-out thất bại!");
  //   }
  // };

  function handleReset() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setQrCode("");
    setData(null);
    inputRef.current?.focus();
  }

  const handleChange = async (e) => {
    const qrRegex = /^[0-9a-f]{32}$/;
    const value = e.target.value;
    const isMatch = qrRegex.test(value);

    setQrCode(value);
    if (!isMatch) {
      setTimeout(handleReset, 1000);

      return;
    }

    try {
      const res = await registrationApi.getCheckInInfo(value, eventId);

      if (res) {
        // Clear previous timer
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }

        setData(res);

        await checkOutQR.mutateAsync(value.trim());
        message.success("✅ Check-out thành công!");

        // Auto-hide data after 15 seconds
        timerRef.current = setTimeout(() => {
          setData(null);
          setQrCode("");
        }, 10000);

        inputRef.current?.focus();
      }

      // Show immediate alert if costume not returned
      // if (res.borrowStatus === "borrowed") {
      //   message.error("Chưa trả áo tràng! Không thể check-out.");
      // }
    } catch (error) {
      console.log(error);
      message.error(`${error}`);
      handleReset();
    }
  };

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: 16 }}>
      <Card style={{ width: "100%" }}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {/* Header */}
          <Card
            bordered={true}
            style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
          >
            <Row align="middle" gutter={16}>
              <Col>
                <QrcodeOutlined style={{ fontSize: 48, color: "#1890ff" }} />
              </Col>
              <Col flex="auto">
                <Title level={3} style={{ margin: 0 }}>
                  Check-out bằng QR Code
                </Title>
                <Text type="secondary">
                  Quét hoặc nhập mã QR để check-out tham gia sự kiện
                </Text>
              </Col>
            </Row>

            <Divider />

            <Descriptions column={2} size="small">
              <Descriptions.Item label="Tên sự kiện">
                {event?.title}
              </Descriptions.Item>
              <Descriptions.Item label="Bắt đầu">
                {new Date(event?.startDate).toLocaleString()}
              </Descriptions.Item>
              <Descriptions.Item label="Kết thúc">
                {new Date(event?.endDate).toLocaleString()}
              </Descriptions.Item>
            </Descriptions>
          </Card>

          {/* Input QR */}
          <Card
            title={
              <Space>
                <SearchOutlined /> Nhập mã QR
              </Space>
            }
            size="small"
            bordered={false}
          >
            <TextArea
              ref={inputRef}
              placeholder="Nhập mã QR hoặc dán từ thiết bị quét"
              value={qrCode}
              onChange={handleChange}
              onBlur={() => inputRef.current?.focus()}
              rows={3}
              style={{ width: "100%" }}
            />

            {qrCode ? (
              <div style={{ marginTop: 8 }}>
                {data ? (
                  data.status !== "attended" ? (
                    <Alert
                      message={
                        data.status === "completed"
                          ? "Đã check-out trước đó"
                          : "Chưa check-in"
                      }
                      type="error"
                      showIcon
                    />
                  ) : (
                    <Alert
                      message="Thông tin hợp lệ"
                      description="Được phép check-out"
                      type="success"
                      showIcon
                    />
                  )
                ) : (
                  <Alert
                    message="Thông tin không hợp lệ"
                    type="error"
                    showIcon
                  />
                )}
              </div>
            ) : null}
          </Card>

          {/* Nút check-out */}
          <Space style={{ width: "100%", justifyContent: "flex-end" }}>
            {/* <Button
              type="primary"
              size="large"
              icon={<ScanOutlined />}
              onClick={handleCheckOut}
              loading={checkOutQR.isPending}
              disabled={
                !data ||
                data?.status !== "attended" ||
                data?.borrowStatus === "borrowed"
              }
            >
              Check-out
            </Button> */}

            <Button
              variant="outlined"
              size="large"
              onClick={handleReset}
              loading={checkOutQR.isPending}
            >
              Reset
            </Button>
          </Space>
        </Space>
      </Card>

      {data && (
        <Row gutter={16} style={{ marginTop: 16 }}>
          <Col xs={24} lg={12}>
            <Card
              title={
                <Space>
                  <CalendarOutlined /> Sự kiện tham gia
                </Space>
              }
              bordered={false}
            >
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="Tên sự kiện">
                  {data.event?.title}
                </Descriptions.Item>
                <Descriptions.Item label="Bắt đầu">
                  {new Date(data.event?.startDate).toLocaleString()}
                </Descriptions.Item>
                <Descriptions.Item label="Kết thúc">
                  {new Date(data.event?.endDate).toLocaleString()}
                </Descriptions.Item>
                {data?.borrowStatus && (
                  <Descriptions.Item
                    label="Trạng thái mượn áo"
                    contentStyle={{ color: "red" }}
                  >
                    {borrowStatus[data.borrowStatus]}
                  </Descriptions.Item>
                )}
              </Descriptions>
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card
              title={
                <Space>
                  <UserOutlined /> Thông tin Phật tử
                </Space>
              }
              bordered={false}
            >
              <Space
                align="center"
                style={{
                  marginBottom: 16,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Avatar
                  size={200}
                  src={data?.avatarUrl || data.user?.avatar || ""}
                  icon={<UserOutlined />}
                  shape="square"
                />
              </Space>
              <div style={{ textAlign: "center", marginBottom: 16 }}>
                <Title level={5} style={{ margin: 0 }}>
                  {data.user?.name}
                </Title>
                <Text type="secondary">
                  {data?.buddhistName || data.user?.buddhistName || "Chưa có pháp danh"}
                </Text>
              </div>
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item
                  label={
                    <Space>
                      <MailOutlined /> Email
                    </Space>
                  }
                >
                  <Space>
                    <span>{data.user?.email}</span>
                    <Button
                      type="text"
                      icon={<CopyOutlined />}
                      onClick={() => {
                        navigator.clipboard.writeText(data.user?.email);
                        message.success("Đã sao chép email");
                      }}
                    />
                  </Space>
                </Descriptions.Item>
                <Descriptions.Item
                  label={
                    <Space>
                      <PhoneOutlined /> Số điện thoại
                    </Space>
                  }
                >
                  {data.user?.phone}
                </Descriptions.Item>
                <Descriptions.Item
                  label={
                    <Space>
                      <HomeOutlined /> Địa chỉ
                    </Space>
                  }
                >
                  {data.user?.address}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
}
